<template>
  <mk-menu
    class="mk-aside-menu ds-aside-menu"
    style="border-right:none;"
    :default-active="defaultActive"
    :collapse="isCollapse"
    background-color="#001529"
    text-color="#8F9FB3"
    active-text-color="#fff"
    :collapse-transition="false"
    unique-opened
    @select="handleOnSelect"
  >
    <template v-for="item in menuList">
      <template v-if="item.menu && item.menu.length">
        <mk-aside-menu-item
          v-if="item.menu && item.menu.length"
          :key="item.id"
          :parent-item="item"
          :is-collapse="!isCollapse"
        />
      </template>
      <template v-else>
        <mk-menu-item
          :key="item.id"
          :index="item.link"
        >
          <mk-iconfont
            :icon-class="item.icon"
            :class="isCollapse ? 'icon-mk': ''"
          >
          </mk-iconfont>
          <span
            slot="title"
            class="menu-title"
          >
            {{ item.name }}
          </span>
        </mk-menu-item>
      </template>
    </template>
  </mk-menu>
</template>

<script>
/*
  1. 自定义icon(使用阿里的iconfont)
  2. 通过数据动态生成菜单（定义数据结构？）
  3. 返回当前点击菜单的节点数据
  4. 思考比较合理的权限管理（动态路由挂载）
*/
import MkAsideMenuItem from './mk-aside-menu-item.vue'
export default {
  name: 'MkASideMenu',
  components: {
    MkAsideMenuItem
  },
  props: {
    menuList: {
      type: Array,
      default () {
        return []
      }
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
    defaultActive: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleOnSelect (index, indexPath) {
      this.$emit('on-select', { index, indexPath })
    }
  }
}
</script>

<style lang="scss">
.ds-aside-menu {
  height: calc(100% - 64px);
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.mk-aside-menu,
.el-menu--vertical {
  .el-menu-item.is-active {
    background-color: #009cff !important;
  }

  .el-menu-item,
  .el-submenu__title {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;

    &:hover {
      color: #fff !important;

      .iconfont {
        color: #fff !important;
      }
    }

    .menu-title {
      padding-left: 13px;
    }
  }
}

.mk-aside-menu {
  &::-webkit-scrollbar {
    display: none;
  }
}

.icon-mk {
  font-size: 18px;
}

.el-menu--popup {
  min-width: 150px;
  padding: 5px 0 !important;
  border: none !important;

  .el-menu-item {
    margin-top: 0;
    padding-left: 34px !important;
    min-width: inherit;
  }
}

</style>
